import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsTemplateService } from '../../../../services/forms-template.service';
import { AnagraficaService } from '../../../../services/anagrafica.service';
import { DxRadioGroupComponent } from 'devextreme-angular';

@Component({
  selector: 'app-input-switch-el',
  templateUrl: './input-switch-el.component.html',
  styleUrls: ['./input-switch-el.component.css']
})
export class InputSwitchElComponent implements OnInit {
  @Input() fileDataInput: any
  @Input() dataInput: any;
  @Input() formGroup
  @Output() switchGroupEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() switchGroupInitialized: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  switchedOffText: string = 'Disattivo'
  switchedOnText: string = 'Attivo'
  switchValue: boolean = false
  classe: string = ''
  readOnly: boolean = false
  width: number | undefined
  height: number | undefined
  hint: string | undefined
  hoverStateEnabled: boolean = true
  constructor() { }

  ngOnInit() {
    const switchBox = this.fileDataInput.switchBox
    const dataField = this.fileDataInput.dataField
    this.classe = switchBox ? switchBox.classe || '' : ''
    this.readOnly = switchBox ? switchBox.readOnly !== undefined ? switchBox.readOnly : false : false
    this.width = switchBox ? switchBox.width !== undefined ? switchBox.width : undefined : undefined
    this.height = switchBox ? switchBox.height !== undefined ? switchBox.height : undefined : undefined
    this.hint = switchBox ? (switchBox.hint !== undefined && switchBox.hint !== '') ? switchBox.hint : undefined : undefined
    this.hoverStateEnabled = switchBox ? switchBox.hoverStateEnabled !== undefined ? switchBox.hoverStateEnabled : true : true
    this.switchedOffText = switchBox ? switchBox.switchedOffText || 'Disattivo' : 'Disattivo'
    this.switchedOnText = switchBox ? switchBox.switchedOnText || 'Attivo' : 'Attivo'
    this.switchValue = this.checkvalue(this.dataInput[dataField], switchBox)

  }

  onSwitchGroupChange(ev, switchGroup) {
    const switchBox = this.fileDataInput.switchBox
    const switchGroupValue = this.setValue(ev.value, switchBox);
    let c = this.formGroup.get(this.fileDataInput.dataField)
    c.setValue(switchGroupValue)

    let event = {
      name: 'switchGroupChange',
      dataField: this.fileDataInput.dataField,
      component: ev.component,
      value: switchGroupValue,
      element: ev.element
    }
    this.switchGroupEvent.emit(event);
  }
  onInitializzedSwitchGroup(event) {
    const switchBox = this.fileDataInput.switchBox
    const dataField = this.fileDataInput.dataField
    const switchGroupValue = switchBox.defaultValue !== undefined ? switchBox.defaultValue : this.setValue(this.dataInput[dataField], switchBox);
    let c = this.formGroup.get(this.fileDataInput.dataField)
    c.setValue(switchGroupValue)
    event.nativeElement = event.element;
    event.dxComponent = event.component;
    event.value = switchGroupValue;
    event.editorComponent = this;
    event.id = this.fileDataInput.dataField
    this.switchGroupInitialized.emit(event);

  }

  checkvalue(dato, config) {
    if (!dato && config && config.defaultValue !== undefined) {
      return config.defaultValue;
    }

    if (!config || (config.trueValue === undefined || config.trueValue === null) || (config.falseValue === undefined || config.falseValue === null)) {
      //console.error('errore');
      return dato === 1;
    }
    if (dato === config.trueValue) {
      return true;
    } else if (dato === config.falseValue) {
      return false;
    } else {
      return dato === 1;
    }
  }

  setValue(dato, config) {
    if (dato === undefined || dato === null) {
      //console.error(config.defaultValue);
      if (config && config.defaultValue) {
        return config.defaultValue;
      } else {
        return false
      }
    }
    if (!config || (config.trueValue === undefined || config.trueValue === null) || (config.falseValue === undefined || config.falseValue === null)) {
      //console.error('errore');
      return dato;
    }
    if (dato === true) {
      return config.trueValue;
    } else if (dato === false) {
      return config.falseValue;
    } else {
      return dato;
    }
  }

}



